import { render, staticRenderFns } from "./TaskProgress.vue?vue&type=template&id=b12b0f60&"
import script from "./TaskProgress.vue?vue&type=script&lang=js&"
export * from "./TaskProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports